export enum TARGET_TYPE {
  AGENT,
  AGENCY,
  CARRIER,
  PROSPECT,
}
